<form [formGroup]="myForm">
  <h3
    mat-dialog-title
    style="
      font-weight: 500;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: 0%;
    "
  >
    <div>Detalle de Tickets - File {{ data.fileNumber }}</div>
  </h3>
  <mat-dialog-content class="column-base align-center">
    <div
      class="column-base align-center"
      style="gap: 10px; padding-bottom: 10px"
    >
      <div class="column-base leyenda-linea">
        <i-tabler name="ticket" class="leyenda-icon"></i-tabler>
        <span class="leyenda-text">{{ data.nombreServicio }}</span>
      </div>
      <span>{{
        data.varianteFrecuencia ?? "Ruta Montaña Machu Picchu - A"
      }}</span>
      <span>{{ data.circuitoTren ?? "Panorámico - 1 " }}</span>
      <span>{{ data.horario ?? "20/03/2025 - 7:00 AM" }}</span>
    </div>
    <h6>Checklist de Tickets</h6>
    <div class="row-base ticket-option" style="gap: 30px; padding: 10px 20px">
      <mat-checkbox (click)="$event.stopPropagation()">
        <!-- (change)="onCheckboxChange(row)"
        [checked]="row.select === true ? true : false" -->
      </mat-checkbox>

      <div class="column-base align-center" style="gap: 4px; padding: 5px 0">
        <span> 10 - Tarifa Adulto </span>
        <span> S/ 1,120.00 </span>
      </div>
    </div>
    <div
      class="row-base ticket-option align-vertical-center"
      style="gap: 30px; padding: 10px 20px"
    >
      <mat-checkbox (click)="$event.stopPropagation()">
        <!-- (change)="onCheckboxChange(row)"
      [checked]="row.select === true ? true : false" -->
      </mat-checkbox>

      <div class="column-base align-center" style="gap: 4px; padding: 5px 0">
        <span> 4 - Tarifa Niño </span>
        <span> S/ 320.00 </span>
      </div>
    </div>

    <div
      class="row-base ticket-option align-vertical-center"
      style="gap: 30px; padding: 10px 20px"
    >
      <mat-checkbox (click)="$event.stopPropagation()">
        <!-- (change)="onCheckboxChange(row)"
    [checked]="row.select === true ? true : false" -->
      </mat-checkbox>

      <div class="column-base align-center" style="gap: 4px; padding: 5px 0">
        <span> 10 - Tarifa Estudiante </span>
        <span> S/ 1,240.00 </span>
      </div>
    </div>

    <div style="gap: 10px" class="row-base align-center align-vertical-center">
      <span
        style="font-weight: 500; color: #69bd79 !important; height: fit-content"
      >
        ¡Tickets Reservados!
      </span>
      <i-tabler
        name="circle-check"
        style="
          width: 20px !important;
          fill: #69bd79 !important;
          stroke: #ffffff !important;
        "
      ></i-tabler>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="w-100 row-base div-center" style="gap: 30px">
    <button
      style="color: #e95a1a; border-color: #e95a1a !important"
      mat-stroked-button
      mat-dialog-close
    >
      Cerrar
    </button>

    <button
      mat-flat-button
      (click)="onSave()"
      class="buttonPrimary row-base div-center div-vertical-center white-spinner"
      style=""
      [style.cursor]="loading ? 'not-allowed' : 'pointer'"
    >
      <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>

      <div *ngIf="!loading">Actualizar</div>
    </button>
  </mat-dialog-actions>
</form>
